import React, {useEffect, useState} from "react";
import {getInspectionReport} from "../../../../api/maintenance/InspectionService";
import {ContentCategory} from "../../../../constant/CodeSpecNum";
import {InspectionReportCreate} from "./InspectionReportCreate";
import {InspectionReportView} from "./InspectionReportView";
import Printer from "../../../../resources/icon/pirnter-bw.png";
import {buildReportViewGroups, groupByGroupNameWithValues} from "../../../../components/commonmethod/CommonMethod";

export const inspectionReportCode = [
    {value: ContentCategory.COMPANY, text : "업체별"},
    {value: ContentCategory.CODE, text: "자산 그룹별"}
];

export const reportReportResultRadio = [
    {value: 0, text : "정상"},
    {value: 1, text: "비정상"},
    {value: 2, text: "미확인"}
];

import {getMaintenanceAssetsFromDetail, getMaintenanceHandlersFromDetail} from "../../shared/maintenanceHandlerUtils";

function InspectionReport({id, inspection, statusNumericValue}){
    const assets = getMaintenanceAssetsFromDetail(inspection);
    const handlers = getMaintenanceHandlersFromDetail(inspection);
    const [inspectionReport, setInspectionReport] = useState({});

    useEffect(() => {
        const fetchInspectionReport = async () => {
            const response = await getInspectionReport(id);

            if (response.data?.id) {
                const report = response.data;

                const codeList = report.inspectionReportCode.children;
                const assetView = report.assetView;
                const reportView = report.reportView;
                
                // groupName 기준으로 child 구성
                const assetGroup = groupByGroupNameWithValues(codeList, assetView);
                const reportGroup = buildReportViewGroups(codeList, reportView);
                
                // 상태 반영
                setInspectionReport({
                    ...report,
                    assetView: assetGroup,
                    reportView : reportGroup
                });
            }
        };

        fetchInspectionReport();
    }, [id, inspectionReport?.id]);

    return (
        <>
            {
                !inspectionReport.id ?
                    <InspectionReportCreate inspection={inspection} assets={assets} handler={handlers} statusNumericValue={statusNumericValue} inspectionReport={inspectionReport} setInspectionReport={setInspectionReport} />
                    :
                    <InspectionReportView inspection={inspection} assets={assets} handler={handlers} statusNumericValue={statusNumericValue} inspectionReport={inspectionReport} setInspectionReport={setInspectionReport} />
            }
        </>
    )
}

export {InspectionReport}